// @ts-nocheck
const TranslatorDashboardSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default TranslatorDashboardSkeleton